import request from '@/utils/request'

// 获取验证码
export function getCaptcha() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

// 学生登录
export function login(data) {
  return request({
    url: '/front/login',
    method: 'post',
    data: data
  })
}

// 获取用户信息
export function getUserInfo(userId) {
  return request({
    url: '/front/userInfo',
    method: 'get',
    params: { userId }
  })
}
